import controller from './application-help.controller';

const template = require('./application-help.html');

export default {
    bindings: {
        onShowFeedbackForm: '&'
    },
    controller,
    template
};



// WEBPACK FOOTER //
// ./app/common/help-menu/application-help/application-help.component.js